// Funcion para tokenizar una tarjeta con OpenPay
export const tokenizeCard = async (cardData) => {
  const orkestapay_card = await window.orkestaPay.createCard(cardData);

  return await orkestapay_card.createToken({ one_time_use: true })
} 

const notifyInput = (el) => {
  el.dispatchEvent(new Event('input', { bubbles: true }));
};

export const resetInput = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  el.value = '';
  notifyInput(el);
};